import { Model } from '@/models/Model'
import Property from '@/decorators/Property'
import { ToOneRelation } from 'coloquent/dist/relation/ToOneRelation'
import { Document } from '@/models/Document'

export class HopperMeasurement extends Model {
	protected jsonApiType = 'hopperMeasurements'

	@Property()
	public holdIsOpen!: boolean

	@Property()
	public holdDimensionsInCubicMeter!: number

	@Property()
	public measurements!: {
		left: Array<number | null>
		right: Array<number | null>
	}

	public bargingLetter(): ToOneRelation {
		return this.hasOne(Document, 'bargingLetter')
	}

	public setBargingLetter(bargingLetter: Document | null) {
		this.setRelation('bargingLetter', bargingLetter)
	}
}
